import { render } from "./ContactsPage.vue?vue&type=template&id=64c13bb6&scoped=true"
import script from "./ContactsPage.vue?vue&type=script&lang=js"
export * from "./ContactsPage.vue?vue&type=script&lang=js"

import "./ContactsPage.vue?vue&type=style&index=0&id=64c13bb6&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c13bb6"]])

export default __exports__